import { render, staticRenderFns } from "./CoachItemPage.vue?vue&type=template&id=4fd1d90c&"
import script from "./CoachItemPage.vue?vue&type=script&lang=js&"
export * from "./CoachItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports